import React from 'react';
import { Modal } from 'antd';
import fontUrl from '@assets/fonts/VinilaVariable.otf';

const injectFont = (html: string) => {
  const fontStyle = `<style>
    @font-face {
      font-family: 'Vinila Variable';
      src: url('${fontUrl}') format('opentype');
      font-weight: 100 900;
      font-style: normal;
      font-display: swap;
    }
    body { font-family: 'Vinila Variable', sans-serif!important; }
  </style>`;
  if (html.includes('<head>')) {
    return html.replace('<head>', `<head>${fontStyle}`);
  }
  return `${fontStyle}${html}`;
};

type PreviewModalProps = {
  html: string | null;
  onClose: () => void;
  title?: string;
};

const PreviewModal: React.FC<PreviewModalProps> = ({
  html,
  onClose,
  title = 'Key Information Document',
}) => {
  return (
    <Modal
      open={!!html}
      title={title}
      onCancel={onClose}
      footer={null}
      width={960}
    >
      <iframe
        srcDoc={html ? injectFont(html) : ''}
        onLoad={(e) => {
          const iframe = e.currentTarget;
          const height =
            iframe.contentDocument?.documentElement?.scrollHeight;
          if (height) iframe.style.height = `${height}px`;
        }}
        style={{
          width: '100%',
          minHeight: '720px',
          height: 'auto',
          margin: '0 auto',
          display: 'block',
          border: 'none',
          background: '#fff',
        }}
        title="Preview"
      />
    </Modal>
  );
};

export default PreviewModal;
